
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.48 49.814c-.47 0-.93-.149-1.32-.428a2.242 2.242 0 01-.9-2.2l1.99-11.549a.276.276 0 00-.07-.229l-8.43-8.173a2.214 2.214 0 01-.57-2.3c.27-.816.96-1.404 1.82-1.523l11.639-1.683c.08-.01.16-.06.19-.14l5.209-10.502a2.235 2.235 0 012.02-1.255c.86 0 1.64.478 2.02 1.254l5.209 10.504c.04.08.11.13.19.14l11.648 1.682c.86.12 1.55.707 1.82 1.523s.05 1.702-.57 2.3l-8.43 8.173a.24.24 0 00-.07.23l1.99 11.548a2.23 2.23 0 01-.9 2.2c-.7.508-1.61.568-2.379.17L30.168 44.1a.256.256 0 00-.24 0l-10.409 5.445c-.32.18-.68.27-1.04.27z"}})])
          )
        }
      }
    